import SecondaryCardPropsType from "../../types/SecondaryCardPropsType"
import ReactVisibilitySensor from "react-visibility-sensor";
import DefaultIcon from '../../assets/icons/sabb-default-icon.svg';
import Counter from "../Counter/Counter";

const SecondaryCard = ({
    icon ,
    title,
    subtitle,
    number,
} : SecondaryCardPropsType) => {
  return (
    <ReactVisibilitySensor
      // partialVisibility
    >
    {({isVisible} : any) => (
      <div className={`secondary-card ${isVisible ? "visible" : ""}`}>
          <div className="wrapper-small">
            <div className="card-container">
              {icon ? 
              <img src={icon.name} alt={icon.alt} className="card-icon" aria-hidden /> : 
              <img src={DefaultIcon} alt={"Default icon"} className="card-icon" aria-hidden />}
              {title ? <h3 className="card-title">{title}</h3> : ""}
              {number ? 
              <h3 className="card-title">
                <Counter counterValue={number.value} applyCounteClassName="" /> {number.unit}
              </h3> 
              : ""}
              <p className="card-subtitle">{subtitle}</p>
            </div>
          </div>
      </div>

    )}
    </ReactVisibilitySensor>
  )
}

export default SecondaryCard